import React from "react";
import queryString from "query-string";
import CONSTANT from "./../../constant";

import Header from "../../component/common/Header";
import Paging from "../../component/common/Paging";
import FileSearchBar from "./../../component/file/FileSearchBar";

import { getDateParts, getCookie } from "../../utils";
import { searchFiles } from "./../../actions/FileAction";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    let params = queryString.parse(this.props.location.search);
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    this.state = {
      keyword: params.k,
      page: 1,
      limit: 50,
      list: undefined,
      userDetail,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = CONSTANT.pageTitle.login;

    this.loadList();
  }

  render() {
    const { page, list, keyword, userDetail } = this.state;
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2 pl-0">
            <Header />
          </div>

          <div className="col-md-10 mb-3">
            <div className="card homedob p-4 mb-4">
              {/* <div className="row">
                <div className="col-md-12 my-3">
                  <h1 className="page-title">Search result</h1>
                </div>
              </div> */}
              {/* <div className="row">
                            <div className="col-md-12">
                                <div>Search result for <strong><i>{keyword}</i></strong> keyword</div>
                            </div>
                        </div> */}

              <div className="row">
                <div className="col-md-6">
                  {/* <div>
                    Search result for{" "}
                    <strong>
                      <i>{keyword}</i>
                    </strong>{" "}
                    keyword
                  </div> */}
                  <FileSearchBar />
                </div>
                {/* <div className="col-md-6">
                  <FileSearchBar />
                </div> */}
              </div>

              <div className="row">
                <div className="col-md-12 mt-4 mb-5">
                  <div className="list-container">
                    <div className="table-container">
                      <div className="table-wrapper">
                        <table className="tablen">
                          <thead>
                            <tr className="headbg">
                              <th colSpan={8} className="tabheadtitle">
                                Search result{" "}
                                <strong>
                                  <i>{keyword}</i>
                                </strong>{" "}
                                keyword
                              </th>
                            </tr>
                            <tr>
                              <th scope="col">Comp. No.</th>
                              <th scope="col">File Number</th>
                              <th scope="col">Subject</th>
                              <th scope="col">Financial Implication</th>
                              <th scope="col">Dated</th>
                              <th scope="col">Modified</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* <tr>
                        <th scope="col">Comp. No.</th>
                        <th scope="col">File Number</th>
                        <th scope="col">Subject</th>
                        <th scope="col">Financial Implication</th>
                        <th scope="col">Dated</th>
                        <th scope="col">Modified</th>
                      </tr> */}
                            {list === undefined && (
                              <tr>
                                <td colSpan={6} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}
                            {list !== undefined && list.length === 0 && (
                              <tr>
                                <td colSpan={6} className="text-center">
                                  No records found
                                </td>
                              </tr>
                            )}
                            {list !== undefined &&
                              list.map((item: any) => {
                                const detailPageURL =
                                  CONSTANT.component.userFileDetail.url.replace(
                                    ":code",
                                    item.code
                                  );
                                const dated = getDateParts(item.dated);
                                const mo = getDateParts(item.modifiedOn);
                                const closedOn = getDateParts(item.closedOn);
                                const subjectStr =
                                  item.subject.length > 50
                                    ? item.subject.substr(0, 50) + "..."
                                    : item.subject;
                                const isClosed = item.isClosed;
                                // const cssClass = ["c-pointer"];
                                // isClosed && cssClass.push("font-weight-bold");

                                return (
                                  <tr
                                    // className={cssClass.join(" ")}
                                    onClick={() =>
                                      this.openDetailPage(detailPageURL)
                                    }
                                  >
                                    {/* {
                                                                userDetail.isHOD && <td>
                                                                    {
                                                                        isClosed ? 'File is closed' : `${item.pendingWithName}`
                                                                    }
                                                                </td>
                                                            } */}
                                    <td className="sno">{item.code}</td>
                                    <td>{item.fileNumber}</td>
                                    <td className="subject">{subjectStr}</td>
                                    <td className="financial">
                                      {item.financialImplication
                                        ? `${
                                            CONSTANT.static.currencySymbol
                                          } ${parseFloat(
                                            item.financialImplication
                                          ).toLocaleString(
                                            CONSTANT.static.locale
                                          )}`
                                        : "-"}
                                    </td>
                                    <td>
                                      <span className="status-badge modified text-nowrap">{`${dated.date} ${dated.monthName} ${dated.year}`}</span>
                                    </td>
                                    <td><span className="status-badge pending-high text-nowrap">{`${mo.date} ${mo.monthName} ${mo.year}`}</span></td>
                                    {/* <td>{isClosed ? `${closedOn.date} ${closedOn.monthName} ${closedOn.year}` : '-'}</td> */}
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {list !== undefined && (
                <Paging
                  page={page}
                  listItem={list}
                  onPageChange={this.changePage}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  loadList = () => {
    const { keyword, page, limit } = this.state;
    searchFiles(keyword, page, limit).then((res: any) => {
      if (res) this.setState({ list: res.result });
    });
  };

  openDetailPage = (url: string) => {
    this.props.history.push(url);
  };

  changePage = (e: any) => {
    const type = e.target.dataset.type;
    const page = type === "+" ? this.state.page + 1 : this.state.page - 1;
    this.setState({ page }, () => {
      this.loadList();
    });
  };
}

export default ComponentName;
